import { ref } from 'vue'

/** Thin fetch wrapper for the api Worker. A 401 flips `signedIn` so App.vue shows the sign-in screen. */
export const signedIn = ref<boolean | null>(null)
export const onSignedOut: (() => void)[] = []

export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message)
  }
}

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`/api/v1${path}`, { credentials: 'same-origin', ...init,
    headers: { 'content-type': 'application/json', ...(init?.headers ?? {}) } })
  if (res.status === 401) {
    signedIn.value = false
    onSignedOut.forEach((f) => f())
  }
  const body = await res.json().catch(() => ({}))
  if (!res.ok) throw new ApiError((body as { error?: string }).error ?? res.statusText, res.status)
  return body as T
}

export const qs = (params: Record<string, string | boolean | undefined | null>) => {
  const p = new URLSearchParams()
  for (const [k, v] of Object.entries(params)) if (v !== undefined && v !== null && v !== '') p.set(k, String(v))
  const s = p.toString()
  return s ? `?${s}` : ''
}

export async function signOut() {
  await api('/auth/logout', { method: 'POST' }).catch(() => {})
  signedIn.value = false
  onSignedOut.forEach((f) => f())
}
